<template>
  <div class="radio-group">
    <div
      v-for="option in options"
      class="radio-group__inner"
      :class="itemClass"
      :key="option.id"
      @click="$emit('input', option.id)"
    >
      <div
        :class="{
          'radio-circle': true,
          'radio-circle--selected': value === option.id
        }"
      ></div>
      <slot :option="option" />
    </div>
  </div>
</template>

<script>
export default {
  name: "VRadioGroup",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Number,
      default: null
    },
    itemClass: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/variables";

.radio-group {
  &__inner {
    display: flex;
    cursor: pointer;
  }
}
.radio-circle {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #999999;
  position: relative;
  margin: 3px 0 0 3px;
  &--selected {
    border-color: #000;
    &::after {
      position: absolute;
      width: 10px;
      height: 10px;
      content: "";
      left: 50%;
      top: 50%;
      margin: -5px;
      background: #000;
      border-radius: 50%;
    }
  }
}
</style>
